import NextIcon from 'assets/icons/next.svg';
import moment from 'moment';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { TooltipText } from 'presentation/components/TooltipText';
import { COMMON } from 'utilities/constants/COMMON';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { DataListedProperty } from '../models/Model_CU-049-01';

interface props {
    data: DataListedProperty;
    onClickViewDetail: (value: number) => void;
}

export const CardComponent = ({ data, onClickViewDetail }: props) => {
    return (
        <section
            className="card-element button-style glow-on-hover"
            onClick={() => onClickViewDetail(data.id)}
        >
            <div style={{ width: '100%', height: 143, marginBottom: 24 }}>
                <ImageComponent alt="" width={231} height={143} src={data?.imageFilePath} />
            </div>
            <section
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
                <div style={{ textAlign: 'left' }}>
                    <div className="title" style={{ marginBottom: 9, width: '195px' }}>
                        <TooltipText content={data.propertyName} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                        <div className="label" style={{ minWidth: 40, marginRight: 8 }}>
                            住所
                        </div>
                        <div className="content">
                            <TooltipText
                                content={data.residence ? data.residence : COMMON.EMPTY}
                                maxLine={2}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                        <div className="label" style={{ minWidth: 40, marginRight: 8 }}>
                            最寄駅
                        </div>
                        <div className="content">
                            <TooltipText
                                content={data.stationName ? data.stationName : COMMON.EMPTY}
                                maxLine={2}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="label" style={{ minWidth: 40, marginRight: 8 }}>
                            築年月
                        </div>
                        <div className="content">
                            {moment(data.builtAt, true).isValid()
                                ? moment(data.builtAt).format(DATE_FORMAT.FORMAT3)
                                : COMMON.EMPTY}
                        </div>
                    </div>
                </div>
                <div className="button-style">
                    <img alt="" src={NextIcon} />
                </div>
            </section>
        </section>
    );
};
